export default __webpack_public_path__ + "static/6-tips-for-shopping-while-on-holiday-pack-light-a8d2497e289bf2a160e76a1844b8cf6d.jpg";